import { axiosV2, getError, getResponse, settings } from '../../helpers/UtilsHelper';

const { app } = settings;
const { backend } = app;
const { urls } = backend;

export const NotificationToastService = {
    /**
     * Get all notification toasts
     * @param {Object} params
     * @param {string} params.token
     * @param {string} params.subMethod
     * @returns {Promise<Object>}
     */
    getAll: async ({
        token = '',
        subMethod = ''
    } = {}) => {
        const currentMethod = 'NotificationToastService.getAll';
        let response = getResponse({ type: 0 });
        try {
            const headers = { authorization: `bearer ${token}` };
            const dataObj = { conditionals: [], ordersBy: [], limit: 0 };
            response = await axiosV2?.post({
                url: `${urls?.url}${urls?.apiV1}${urls?.notificationToasts}/`,
                data: dataObj,
                headers,
                subMethod: currentMethod
            });
            return response;
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
    }
};
